import chalk from "chalk";
import ora from "ora";
import { EvaluatorsApiService } from "@/client-sdk/services/evaluators";
import type { EvaluatorResponse } from "@/client-sdk/services/evaluators";
import { checkApiKey } from "../../utils/apiKey";
import { failSpinner } from "../../utils/spinnerError";

const formatEvaluatorDetails = (evaluator: EvaluatorResponse): void => {
  const config = evaluator.config as
    | { evaluatorType?: string; settings?: Record<string, unknown> }
    | null
    | undefined;
  const evaluatorType = config?.evaluatorType ?? evaluator.type ?? "—";

  console.log();
  console.log(chalk.bold.cyan(evaluator.name));
  console.log(chalk.gray("─".repeat(40)));

  console.log(`  ${chalk.gray("ID:")}          ${evaluator.id}`);
  console.log(`  ${chalk.gray("Slug:")}        ${evaluator.slug ?? chalk.gray("—")}`);
  console.log(`  ${chalk.gray("Type:")}        ${chalk.yellow(evaluatorType)}`);
  console.log(`  ${chalk.gray("Created:")}     ${new Date(evaluator.createdAt).toLocaleString()}`);
  console.log(`  ${chalk.gray("Updated:")}     ${new Date(evaluator.updatedAt).toLocaleString()}`);

  if (evaluator.workflowId) {
    console.log(`  ${chalk.gray("Workflow ID:")} ${evaluator.workflowId}`);
  }

  if (evaluator.fields.length > 0) {
    console.log();
    console.log(chalk.bold("  Input Fields:"));
    evaluator.fields.forEach((field) => {
      const optional = field.optional ? chalk.gray(" (optional)") : "";
      console.log(`    ${chalk.green("•")} ${field.identifier}: ${chalk.gray(field.type)}${optional}`);
    });
  }

  if (evaluator.outputFields.length > 0) {
    console.log();
    console.log(chalk.bold("  Output Fields:"));
    evaluator.outputFields.forEach((field) => {
      const optional = field.optional ? chalk.gray(" (optional)") : "";
      console.log(`    ${chalk.green("•")} ${field.identifier}: ${chalk.gray(field.type)}${optional}`);
    });
  }

  if (config?.settings && Object.keys(config.settings).length > 0) {
    console.log();
    console.log(chalk.bold("  Settings:"));
    for (const [key, value] of Object.entries(config.settings)) {
      const displayValue =
        typeof value === "object"
          ? JSON.stringify(value)
          : `${value as string | number | boolean}`;
      console.log(`    ${chalk.gray(key + ":")} ${displayValue}`);
    }
  }

  if (evaluator.platformUrl) {
    console.log(`  ${chalk.bold("View:")}  ${chalk.underline(evaluator.platformUrl)}`);
  }

  console.log();
};

export const getEvaluatorCommand = async (idOrSlug: string, options?: { format?: string }): Promise<void> => {
  checkApiKey();

  const service = new EvaluatorsApiService();
  const spinner = ora(`Fetching evaluator "${idOrSlug}"...`).start();

  try {
    const evaluator = await service.get(idOrSlug);
    spinner.succeed(`Found evaluator "${evaluator.name}"`);
    if (options?.format === "json") {
      console.log(JSON.stringify(evaluator, null, 2));
      return;
    }
    formatEvaluatorDetails(evaluator);
  } catch (error) {
    failSpinner({ spinner, error, action: "fetch evaluator" });
    process.exit(1);
  }
};
